// Account Payable States

import i18n from '@/i18n'

export default {
  accountPayableList: [],
  accountPayableInfo: {},
  accountPayableBalanceDetails: {},
  paymentTypes: [{ text: i18n.t('Cash'), value: 'Cash' }, { text: i18n.t('Remittance'), value: 'Remittance' }]
}
